import React, { useState } from 'react';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { LibraryExportModal } from './LibraryExportModal';

export const LibraryExportButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <SlButton
        variant="normal"
        onClick={handleOpenModal}
        buttonSx={{
          paddingX: '20px'
        }}
      >
        Export
      </SlButton>
      <LibraryExportModal open={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};
